import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import AdminUpdatesPopup from "../admin/updates/AdminUpdatesPopup";

export default function RequireRole({ allowed = [] }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  const role = (user.access_type || "").toUpperCase();
  const normalizedAllowed = allowed.map((r) => r.toUpperCase());
  const ok = normalizedAllowed.includes(role);
  const showUpdatesPopup = normalizedAllowed.includes(role);

  if (!ok) return <Navigate to={role === "ADMIN" ? "/admin/dashboard" : "/dashboard"} replace />;

  return (
    <>
      {showUpdatesPopup ? <AdminUpdatesPopup user={user} role={role} /> : null}
      <Outlet />
    </>
  );
}
